export const TRIPS_HOME_ROUTE = `/`;

export const TRIPS_PATH = `/trips`;

export const TRIPS_ERROR_PATH = `/trips`;
